var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditXs = function SvgEditXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 21a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.412 3.174a4 4 0 0 1 5.657 0l.757.758a4 4 0 0 1 0 5.657l-6.906 6.906a2 2 0 0 1-1.015.545l-4.503.918a2 2 0 0 1-2.36-2.359l.918-4.504a2 2 0 0 1 .546-1.014zm4.242 1.415a2 2 0 0 0-2.828 0L13.414 5 17 8.586l.412-.411a2 2 0 0 0 0-2.829zM8.414 10 12 6.415 15.586 10 12 13.586zM7 11.415l-.08.08-.918 4.504 4.504-.918.08-.08z",
    clipRule: "evenodd"
  })));
};
export default SvgEditXs;